export function init() {
    const $blogPost = $('.main__body--article');

    if ($blogPost.length) {
        $("blockquote").each(function (index) {
            // Remove any forced span styles within blockquote paragraph
            $('p > span').removeAttr('style');
            formatBlockquote(index);
         });
    }
}

function formatBlockquote(index) {
    let content = $("blockquote").eq(index).html();
    $("blockquote").addClass("grid-x");
    $("blockquote").eq(index).html('<div class="shrink cell pullquote"><img src="/Static/img/pullquote-2.png" width="100" height="149" alt="Quotation mark"></div><div class="auto cell">' + content + '</div>');
}